/**
* 班级内人员列表
*/
<template>
    <span>
        <a @click="openmodel()">详情</a>
        <a-modal :visible="visible" :width="1280" title="班级内人员详情" @ok="okmodel" @cancel="cancelmodel">
            <a-divider></a-divider>
            <div>
                <a-table :dataSource="squaduserlist" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" bordered>
                    <a-table-column key="username" title="姓名" data-index="user_name" />
                    <a-table-column key="campusname" title="校区" data-index="campus_name" />
                    <!--   <a-table-column key="gradename" title="年级" data-index="grade_name" /> -->
                    <a-table-column key="squadname" title="班级" data-index="squad_name" />
                    <a-table-column key="fabu_id" title="操作" score="item">
                        <template slot-scope="text, record">
                            <a-button type="dashed" v-if="record.fabu_id > 0"
                                @click="delmission(mission_id, record.squad_id, record.user_id)">撤销</a-button>
                            <a-button type="primary" v-if="record.fabu_id == null"
                                @click="addusermission(mission_id, record.squad_id, record.user_id)">新增</a-button>
                    </template>
                </a-table-column>
                <!-- <a-table-column key="action" title="操作">
                       <template slot-scope="text, record">
                           <span>
                               <a @click="shengchengmission(record.id)">查看</a>
                               </span>
                       </template>
                   </a-table-column> -->
                <!-- <a-table-column key="type" title="班型">
                        <template slot-scope="item">
                            <span v-if="item.type==0">培优班</span>
                            <span v-if="item.type==1">提高班</span>
                            <span v-if="item.type==2">英才班</span>
                                <span v-if="item.type==3">1对1VIP班</span>
                        </template>
                    </a-table-column> -->
                <!-- <a-table-column key="opening" title="开班状态">
                        <template slot-scope="item">
                            <span v-if="item.opening==0">未开班</span>
                            <span v-if="item.opening==1">已开班</span>
                                <span v-if="item.opening==2">已结班</span>
                            </template>
                        </a-table-column> -->

                </a-table>
                <div>总共{{ pageinfo.total }}条数据</div>
            </div>

        </a-modal>
    </span>
</template>
<script>
export default {
    components: {},
    props: {
        itemdata: {},
        mission_id: undefined,
    },
    data() {
        return {
            data: [],
            pageinfo: {
                total: 1,
                current: 1,
                pageSize: 10
            },
            squaduserlist: [],
            loading: false,
            visible: false,
        };
    },
    mounted() {

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    selectedRows;
                    //  this.squad_id = selectedRowKeys;
                    // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                },

            };
        },
    },
    methods: {
        getTableList() {
            this.loading = true;
            this.$axios
                .post("/api/CoreUserMission/getmissionsquaduserlist", {
                    data: {
                        squad_id: this.itemdata.id,
                        mission_id: this.mission_id,
                    },
                    pageinfo: this.pageinfo
                })
                .then(res => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定"
                        });
                        this.squaduserlist = null;
                    } else {
                        this.squaduserlist = res.data.data;
                        this.pageinfo = res.data.pageinfo;
                    }
                })
                .catch(err => {
                    console.error(err);
                }).finally(() => {
                    this.loading = false;
                })
        },

        /// 撤销学任务
        delmission(mission_id, squad_id, user_id) {
            let _this = this;
            this.$confirm({
                title: "撤销学生任务",
                content: "确认撤销学生任务?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicMission/clearusermission", {
                            data: {
                                mission_id: mission_id,
                                squad_id: squad_id,
                                user_id: user_id
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getTableList();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },

        /// 补发学生任务
        addusermission(mission_id, squad_id, user_id) {
            let _this = this;
            this.$confirm({
                title: "撤销学生任务",
                content: "确认撤销学生任务?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicMission/bufausermission", {
                            data: {
                                mission_id: mission_id,
                                squad_id: squad_id,
                                user_id: user_id
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getTableList();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });
        },

        openmodel() {
            this.visible = true;
            this.getTableList();
        },
        okmodel() {
            this.visible = false;
        },
        cancelmodel() {
            this.visible = false;
        },

        onPaginationChange(item) {
            this.pageinfo.current = item.current;
            this.getTableList();
        },


    }
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
